import styled from 'styled-components';

const ElapsedTime = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular};
  color: ${props => props.theme.colors.textSecondary};
  line-height: 16px;
`;

export default ElapsedTime;
